<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-alert :value="true" v-if="error != null" type="error">{{
          error.message
        }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" @submit="signUp">
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="address1"
                  :rules="addressRules"
                  label="Address line 1*"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="address2"
                  label="Address line 2"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="address3"
                  label="Address line 3"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="locality"
                  label="City / Town"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="region"
                  label="County / Region"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-text-field
                  outline
                  v-model="postal_code"
                  :rules="addressRules"
                  label="Postal Code*"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 pb-0>
                <v-select
                  outline
                  :items="countries"
                  v-model="country"
                  item-text="name"
                  :rules="addressRules"
                  label="Country*"
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout row align-center mx-1 py-0>
              <v-flex xs12 pb-0>
                <a v-on:click="skip" class="skip">Skip address input</a>
              </v-flex>
              <v-flex xs12 pb-0>
                <button
                  type="submit"
                  class="button continue"
                  :disabled="!valid"
                >
                  Submit
                </button>
              </v-flex>
            </v-layout>
          </v-form>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  name: "Registration",
  data() {
    return {
      valid: true,
      ssoid: "",
      addressRules: [(v) => !!v || "You must fill in this address field"],
      address1: "",
      address2: "",
      address3: "",
      locality: "",
      region: "",
      postal_code: "",
      country: "",
      address: null,
      countries: [],
      error: null,
      loading: false,
    };
  },
  created() {
    this.$getCurrentUserAttributes().subscribe((userData) => {
      this.ssoid = userData["sub"];
      this.address = JSON.parse(userData["address"]);
      if (typeof this.address.country !== "undefined") {
        this.country = this.address.country;
      }
    });
    fetch("/countries.json")
      .then((r) => r.json())
      .then(
        (json) => {
          this.countries = json.countries;
        },
        (response) => {
          // eslint-disable-next-line
          console.error("Error loading json:", response);
        }
      );
  },
  watch: {
    pass: function (val, oldVal) {
      this.$refs.form.validate();
    },
    passConfirm: function (val, oldVal) {
      this.$refs.form.validate();
    },
  },
  methods: {
    pad(num, size) {
      var s = num + "";
      while (s.length < size) s = "0" + s;
      return s;
    },
    skip() {
      var attributesList = {
        "custom:address_skip": "true",
      };

      this.$updateAttributes(attributesList).subscribe(
        (response) => {

          // if they skipped but were redirected, we want to send then to the returnUrl rather than their profile
          if (localStorage.returnUrl) {
   
            var redirect = localStorage.returnUrl;
                       
            // Clear local storage values before we redirect
            localStorage.removeItem("returnUrl");
            localStorage.removeItem("suppressToken");
            localStorage.removeItem("responseType");
            window.location = redirect

          } else {
            // otherwise we send them to their profile
            this.$router.push("/profile");
          }
        },
        (err) => {
          // eslint-disable-next-line
          console.error(err.message);
          this.error = err;
        }
      );
    },
    crmXCMPush(username) {
      var crmXCMPushURL =
        process.env.VUE_APP_XCM_CRM_API + "/user/push/" + username;
      return axios({
        method: "get",
        url: crmXCMPushURL,
      });
    },
    crmPush(username) {
      var vm = this;
      Promise.all([vm.crmXCMPush(username)]).then(function (results) {
        if (localStorage.completeRegistrationRedirect) {
          var redirect = localStorage.completeRegistrationRedirect;
          localStorage.removeItem("completeRegistrationRedirect");
          window.location = redirect;
        } else {
          vm.$router.push("/confirm");
        }
      });
    },
    signUp(e) {
      e.preventDefault();
      this.loading = true;

      var attributesList = {
        //"given_name": firstName,
      };

      var street_address =
        this.address1 + "\n" + this.address2 + "\n" + this.address3;

      var address = {
        street_address: street_address,
        locality: this.locality,
        region: this.region,
        postal_code: this.postal_code,
        country: this.country,
      };
      attributesList["address"] = JSON.stringify(address);
      var vm = this;
      this.$updateAttributes(attributesList).subscribe(
        (response) => {
          if(localStorage.returnUrl){
            localStorage.completeRegistrationRedirect = localStorage.returnUrl
          }
          vm.crmPush(this.ssoid);
        },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          // eslint-disable-next-line
          console.error(err.message);
          vm.error = err;
        }
      );
    },
  },
};
</script>

<style>
.password-notice {
  margin: 0 0 20px;
  padding: 0 0 40px;
  color: #878787;
  font-size: 15px;
  line-height: 22px;
  border-bottom: 1px solid #eee;
}

.continue {
  float: right;
}

.skip {
  margin-top: 10px;
  float: left;
}
.v-input--switch__track.theme--light.error--text {
  color: rgba(0, 0, 0, 0.38) !important;
}
.v-input--selection-controls__ripple.error--text {
  color: #fff !important;
}
.v-input--switch__thumb.theme--light.error--text {
  color: #fafafa !important;
}
</style>